import React, { useContext, useEffect, useState } from "react";
import {
    ConfirmDialog,
    FailureSeverity,
    FormFields,
    FormValidationSummary,
    ValidationResult,
    createFailure,
    createValidationResult,
    useNotifications
} from "sprint-common-web";

import { useOrdersModuleApi } from "../../../common/useOrdersModuleApi";
import { OrderListingContext } from "../context/OrderListingContext";
import { OrderListingItem } from "../OrderListingItem";

type RequestOrderWatermarkDialogProps = {
    isOpen: boolean;
    item: OrderListingItem;
    onCancel(): void;
    onSubmit(): void;
};

export const RequestOrderWatermarkDialog: React.VFC<RequestOrderWatermarkDialogProps> = ({
    item,
    isOpen,
    onCancel,
    onSubmit
}: RequestOrderWatermarkDialogProps) => {
    const { updateOrder } = useContext(OrderListingContext);
    const { requestOrderWatermark, validateIfOrderHasWatermarkRule } = useOrdersModuleApi();
    const { success, error } = useNotifications();
    const [missingRuleError, setMissingRuleError] = useState<ValidationResult>({ failures: [], isValid: true });
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        validateIfOrderHasWatermarkRule({ orderId: item.id })
            .then((res) => {
                if (!res.isValid) {
                    setMissingRuleError(
                        createValidationResult([
                            createFailure(
                                "Missing watermark rule for distributor associated with this order. Watermark won't be applied.",
                                "missing-watermark-rule",
                                FailureSeverity.Error
                            )
                        ])
                    );
                }
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, []);

    const handleSubmit = () => {
        requestOrderWatermark({ orderId: item.id })
            .then(() => {
                updateOrder({ id: item.id, isWatermark: true });

                onSubmit();

                success("Order requested to add a watermark");
            })
            .catch(() => {
                error("Cannot request order to add a watermark");
            });
    };

    return (
        <ConfirmDialog
            title="Request order watermark"
            text="Are you sure you want to re watermark rule?"
            hidden={!isOpen}
            confirm={{ onClick: handleSubmit, disabled: !missingRuleError.isValid || isLoading }}
            cancel={{ onClick: onCancel }}
            width={500}
        >
            {!missingRuleError.isValid && (
                <FormFields>
                    <FormValidationSummary validationResult={missingRuleError} />
                </FormFields>
            )}
        </ConfirmDialog>
    );
};
